"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Avatar = require("./Avatar.styles");

var Avatar = function Avatar(_ref) {
  var caption = _ref.caption,
      className = _ref.className,
      src = _ref.src,
      subtext = _ref.subtext;
  var DisplayCaption = typeof caption === 'string' ? /*#__PURE__*/_react["default"].createElement(_Avatar.StyledCaption, null, caption) : caption;
  var DisplaySubtext = typeof subtext === 'string' ? /*#__PURE__*/_react["default"].createElement(_Avatar.StyledSubtext, null, subtext) : subtext;
  return /*#__PURE__*/_react["default"].createElement(_Avatar.StyledContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_Avatar.StyledImage, {
    src: src
  }), caption && DisplayCaption, subtext && DisplaySubtext);
};

Avatar.defaultProps = {
  caption: null,
  className: null,
  subtext: null
};
Avatar.propTypes = {
  /** optional text to display below the avatar */
  caption: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** image to display inside of the avatar */
  src: _propTypes.string.isRequired,

  /** Text to display below the caption */
  subtext: _propTypes.string
};
Avatar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Avatar",
  "props": {
    "caption": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "optional text to display below the avatar",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "subtext": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Text to display below the caption",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "src": {
      "description": "image to display inside of the avatar",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Avatar);

exports["default"] = _default;